

const TrendsArgument = ({ design, category, trends }) => {
  return <div className="text-xs h-3/4 shrink grow">
    <p ><span className="font-semibold text-xs lg:text-lg">TREND CALCULATION</span> : </p>
    <div className="h-4/5 overflow-y-scroll border border-black my-0.5 ">
      <table className="w-full table-auto">
        <thead className="sticky top-0 bg-slate-100 z-20">
          <tr>
            <th className="border-r-2 border-slate-700 p-0.5 z-30">Attributes</th>
            <th className="border border-slate-700 p-0.5" colSpan={2}>In past 7 days:</th>
            <th className="border border-slate-700 p-0.5">Attribute type:</th>
            <th className="border border-slate-700 p-0.5"> In past 15 days</th>
          </tr>
        </thead>
        {trends
          .sort((a, b) => {
            return a.rankSum - b.rankSum
          })
          .map(trend => <tr key={`${trend.tag}-${trend.value}`}>
            <td className="border border-slate-700 p-0.5">{trend.value}</td>
            <td className="border border-slate-700 p-0.5">#{trend.depthRank} dominant trend </td>
            <td className="border border-slate-700 p-0.5">#{trend.rogRank} rising trend </td>
            <td className="border border-slate-700 p-0.5">In {category} {trend.tag}</td>
            <td className="border border-slate-700 p-0.5">
              <p>ROG: {Math.ceil(trend.rateOfGrowth15days * 1000) / 10}% | Depth :{Math.ceil(trend.depth15days * 1000) / 10}%</p>
            </td>
          </tr>)}


      </table>
    </div>

  </div>
}

export default TrendsArgument
